import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { RequestConfig } from '@/../types/interface/config';
import { getHeader, mergeConfig, getRequestUrl, success, fail, getAxiosConfig } from './utils';
import instance from './instance';
import { delObjEmptyProVal } from '../utils/ways';

/**
 * version 注释说明，目前terra前缀的网关都是都是java接口，headers中不需要添加:
 * Accept: 'application/vnd.linhuiba.v' + version + '+json',
 * 如果传了就会导致代理服务器无法设置响应头 content-encoding: gzip，就没有压缩
 */
/**
 * Get 请求
 * @param serviceName 请求地址 | 接口path
 * @param param 接口参数
 * @param extraConfig 自定义配置
//  * @param version 接口版本
 */
export async function axiosGet(
  serviceName: string,
  param = {},
  extraConfig: RequestConfig = {},
  // version: 1
): Promise<any> {
  const customHeader = await getHeader();
  instance.defaults.headers = { ...instance.defaults.headers, ...customHeader };
  const config = mergeConfig(extraConfig);
  const requestUrl = getRequestUrl(serviceName, config);
  const axiosConfig: AxiosRequestConfig = getAxiosConfig(config, {
    params: config.isDelObjEmptyProVal ? delObjEmptyProVal(param) : param,
  });
  try {
    const response: AxiosResponse = await instance.get(requestUrl, axiosConfig);
    return success(response, config);
  } catch (err) {
    return fail(err, config);
  }
}

/**
 * Post 请求
 * @param serviceName 请求地址 | 接口path
 * @param data 接口参数
 * @param extraConfig 自定义配置
//  * @param version 接口版本
 */
export async function axiosPost(
  serviceName: string,
  data = {},
  extraConfig: RequestConfig = {},
  // version: 1
): Promise<any> {
  const customHeader = await getHeader();
  instance.defaults.headers = { ...instance.defaults.headers, ...customHeader };
  const config = mergeConfig(extraConfig);
  const requestUrl = getRequestUrl(serviceName, config);
  const axiosConfig: AxiosRequestConfig = getAxiosConfig(config);
  try {
    const response: AxiosResponse = await instance.post(
      requestUrl,
      config.isDelObjEmptyProVal ? delObjEmptyProVal(data) : data,
      axiosConfig
    );
    return success(response, config);
  } catch (err) {
    return fail(err, config);
  }
}

/**
 * Put 请求
 * @param serviceName 请求地址 | 接口path
 * @param data 接口参数
 * @param extraConfig 自定义配置
 * @param version 接口版本
 */
export async function axiosPut(
  serviceName: string,
  data = {},
  extraConfig: RequestConfig = {},
  // version: 1
): Promise<any> {
  const customHeader = await getHeader();
  instance.defaults.headers = { ...instance.defaults.headers, ...customHeader };
  const config = mergeConfig(extraConfig);
  const requestUrl = getRequestUrl(serviceName, config);
  const axiosConfig: AxiosRequestConfig = getAxiosConfig(config);
  try {
    const response: AxiosResponse = await instance.put(
      requestUrl,
      // delObjEmptyProVal(data),
      config.isDelObjEmptyProVal ? delObjEmptyProVal(data) : data,
      axiosConfig
    );
    return success(response, config);
  } catch (err) {
    return fail(err, config);
  }
}

/**
 * Delete 请求
 * @param serviceName 请求地址 | 接口path
 * @param extraConfig 自定义配置
 * @param version 接口版本
 */
export async function axiosDelete(
  serviceName: string,
  param = {},
  extraConfig: RequestConfig = {},
  // version: 1
): Promise<any> {
  const customHeader = await getHeader();
  instance.defaults.headers = { ...instance.defaults.headers, ...customHeader };
  const config = mergeConfig(extraConfig);
  const requestUrl = getRequestUrl(serviceName, config);
  const axiosConfig: AxiosRequestConfig = getAxiosConfig(config, {
    // params: param
    params: config.isDelObjEmptyProVal ? delObjEmptyProVal(param) : param,

  });
  try {
    const response: AxiosResponse = await instance.delete(requestUrl, axiosConfig);
    return success(response, config);
  } catch (err) {
    return fail(err, config);
  }
}
